import React, { useContext, useState, useEffect } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Text } from '@hz-design-system/web-ui';

import EnvironmentContext from '../../../contexts/EnvironmentContext';
import getStaticImageUrl from '../../../utils/getStaticImageUrl';

import Classes from './BundleFeature.scss';

type BundleFeatureProps = {
  image?: string;
  title: string;
  description: string;
  isEven: boolean;
};

const BundleFeature = ({ image, title, description, isEven }: BundleFeatureProps) => {
  const { staticBaseUrl } = useContext(EnvironmentContext);

  const rootClasses = [Classes.root];
  if (isEven) {
    rootClasses.push(Classes.isEven);
  }
  return (
    <div className={rootClasses.join(' ')}>
      <div className={Classes.content}>
        <h2>{title}</h2>
        {/* @ts-expect-error - dangerouslySetInnerHTML is not part of Text interface */}
        <Text.Regular dangerouslySetInnerHTML={{ __html: description }} />
      </div>
      <div className={Classes.image}>{image && <img src={getStaticImageUrl(staticBaseUrl, image)} alt={title} />}</div>
    </div>
  );
};

const BundleFeatures = () => {
  const i18n = useI18nContext();
  const environment = useContext(EnvironmentContext);
  const [images, setImages] = useState<string[]>([]);

  const { tenant, locale } = environment;

  const fetchImages = () =>
    Promise.all([
      import(`../../../../images/bundle-page/${tenant}/${locale}/sellerpage-about.png`),
      import(`../../../../images/bundle-page/${tenant}/${locale}/sellerpage-ads.png`),
    ])
      .then((loadedImages) => loadedImages.map((image) => image.default))
      .then((imagePaths) => setImages(imagePaths));

  useEffect(() => {
    fetchImages();
  }, [fetchImages, images]);

  const features = [
    {
      title: 'landingFreeBundle.features.feature1.title',
      description: 'landingFreeBundle.features.feature1.body',
      image: images[0],
    },
    {
      title: 'landingFreeBundle.features.feature2.title',
      description: 'landingFreeBundle.features.feature2.body',
      image: images[1],
    },
  ];

  return (
    <>
      {features.map((feature, index) => (
        <BundleFeature
          title={i18n.t(feature.title)}
          description={i18n.t(feature.description)}
          image={feature.image}
          isEven={index % 2 === 0}
          key={index}
        />
      ))}
    </>
  );
};

export default BundleFeatures;
